import React from 'react';
import { SSRProvider } from 'react-bootstrap'; 
import { Provider } from 'react-redux';
import store from './src/state/store';
import { GlobalDataProvider } from './src/context/globalDataContxt';
import globalData from './public/global-data/globalData.json';

// Incluyendo Redux y Context al proyecto
export const wrapRootElement = ({ element }) => (
  <SSRProvider>
    <Provider store={store}>
      <GlobalDataProvider value={globalData}>
        {element}
      </GlobalDataProvider>
    </Provider>
  </SSRProvider>
);